import * as React from "react";
import './OverviewHTMLBlock.pcss';
import {StringHelpers} from "shared/StringHelpers";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";
import FullPostModalData from "data/FullPostModalData";

/**
 * Rendered HTML Block to be re-used in various detail pages
 * and for the display of p, h2, h3, and li HTML elements
 *
 * @param props
 * @constructor
 */
export const OverviewHTMLBlock = (props:{ html:string}) => {
  const safeHtml = StringHelpers.safeHTML(props.html);
  if(null!=safeHtml) {
    return <HeaderLevelCorrectedContent className="overview-html-block" content={safeHtml} offset={'bundle-overview'} />
  } else {
    return null;
  }
}
